import { render, staticRenderFns } from "./SelectRecdInfo.vue?vue&type=template&id=f617e63c&scoped=true&"
import script from "./SelectRecdInfo.vue?vue&type=script&lang=js&"
export * from "./SelectRecdInfo.vue?vue&type=script&lang=js&"
import style0 from "./SelectRecdInfo.vue?vue&type=style&index=0&id=f617e63c&lang=less&scoped=true&"
import style1 from "./SelectRecdInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f617e63c",
  null
  
)

export default component.exports